import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { createContext, useMemo } from "react";

import { SavedFilter } from "types/generated";

import { SAVED_VIEWS_LIST } from "./gql";
import { SavedViewsListGql } from "./types";

type SavedFiltersContextType = {
  loading: boolean;
  data?: SavedViewsListGql;
  privateViews?: SavedFilter[];
  publicViews?: SavedFilter[];
};

export const SavedFiltersContext = createContext<SavedFiltersContextType | undefined>(undefined);
SavedFiltersContext.displayName = "SavedFiltersContext";

type SavedFiltersProps = {
  children: React.ReactNode;
  filterType: string;
};

export const SavedFiltersProvider = ({ children, filterType }: SavedFiltersProps) => {
  const { loading, data, networkStatus } = useQuery<SavedViewsListGql>(SAVED_VIEWS_LIST, {
    variables: {
      type: filterType,
    },
  });

  const privateViews = useMemo(
    () => data?.savedFilters.filter((filter) => !filter.isPublic),
    [data?.savedFilters]
  );

  const publicViews = useMemo(
    () => data?.savedFilters.filter((filter) => filter.isPublic),
    [data?.savedFilters]
  );

  const value = {
    loading: loading && networkStatus === NetworkStatus.loading && !data?.savedFilters,
    data,
    privateViews,
    publicViews,
  };

  return <SavedFiltersContext.Provider value={value}>{children}</SavedFiltersContext.Provider>;
};
